import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from "@angular/router";
import { NewLoginService } from "@providers/NewLogin.service";
import { SPORTS_PATHS } from "../configuration/constants/routes";
import { GlobalVarsModel } from "../models/ModelGlobalsVar";
import { NewBaseService } from "../providers/newBase.service";

export const KEY_REQUIRED_LOGGED = "requiredLogged";

export const AuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  try {
    const router = inject(Router);
    let globalVars!: GlobalVarsModel;
    const newBaseService = inject(NewBaseService);
    newBaseService.getVars.subscribe((data: GlobalVarsModel) => {
      globalVars = data;
    });

    const required =
      route.data[KEY_REQUIRED_LOGGED] !== undefined && route.data[KEY_REQUIRED_LOGGED] !== null
        ? route.data[KEY_REQUIRED_LOGGED]
        : true;

    if (globalVars.user.logged !== required) {
      router.navigateByUrl(SPORTS_PATHS.HomePage);
      if (required) {
        const newLoginService = inject(NewLoginService);
        if (newLoginService.canOpenLogin()) {
          globalVars.rootScope.openLogin(() => {
            if (globalVars.user.logged) {
              router.navigateByUrl(state.url);
            }
          });
        }
      }
      return false;
    }
    return true;
  } catch (e) {
    console.error(e);
    return false;
  }
};
